import { BaseHandler } from "../../../../infrastructure/base-handlers";
import { diagnosticFilterEnabledValuesSelector } from "../selectors";
import { deleteDiagnosticFilterValue } from "./actions";
import { DeleteDiagnosticFilterValueCommand } from "./request";

export class DeleteDiagnosticFilterValueHandler extends BaseHandler {
  async handle(request: DeleteDiagnosticFilterValueCommand) {
    try {
      const enabledDiagnostics = diagnosticFilterEnabledValuesSelector(this.store.getState());
      const diagnosticToDelete = enabledDiagnostics.find((d) => d.codi === request.payload.diagnosticCodi);
      if (diagnosticToDelete) {
        const { evolucions, relacions, ...diagnosticParent } = diagnosticToDelete;
        this.api.broker.publish(this.api.broker.events.activityHistory.diagnosticFilterDeactivated, {
          diagnostic: diagnosticParent,
        });
      }
      this.store.dispatch(deleteDiagnosticFilterValue(request.payload));
    } catch (e) {
      console.error(e.message);
    }
  }
}
